export default __webpack_public_path__ + "static/media/google_business.852c97f4.png";